import * as React from "react";
import styled from "styled-components";
import { HXButton } from "./HXButton";
import { colors } from "healthex-common/colors";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { FlexColumn, FlexRowDiv } from "./common.styles";
import { Subtitle, Text } from "./HXDesktopPage.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { ContentContainer as SharedContentContainer } from "./AccountSettings.styles";
export const ContentContainer = styled(SharedContentContainer) `
    padding: 24px 0px 0px 0px;
`;
export const Section = styled(FlexColumn) `
    width: 700px;
    gap: 24px;
`;
export const PermissionRowContainer = styled(FlexRowDiv) `
    align-items: center;
    align-content: center;
    gap: 8px;
    align-self: stretch;
    flex-wrap: wrap;
`;
export const PermissionRowTextContainer = styled(FlexColumn) `
    gap: 4px;
    flex: 1 0 0;
`;
export const Title = styled(Subtitle) `
    font-size: ${fontSizes.SUPER};
`;
export const ManageAccountsIcon = styled(ManageAccounts) `
    width: 32px;
    height: 32px;
    color: ${colors.accents_sunset};
`;
export const OrgEnabledTopRowContainer = styled(FlexRowDiv) `
    height: 40px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
export const OrgEnabledTopRowTitleContainer = styled(FlexRowDiv) `
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
`;
export const AllowedText = styled(Text) `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${(props) => (props.allowed ? colors.forest_main : colors.tulip_main)};
`;
export const AlwaysAllowedText = styled(AllowedText) `
    color: ${colors.black_30};
`;
export const AdminSettingsButton = styled(HXButton).attrs({
    endIcon: React.createElement(ChevronRight),
    text: true,
    children: "Edit in admin settings",
}) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
